import CreateTrainingSourceButton from "@/admin/training-sources/CreateTrainingSourceButton"
import TrainingSourceTable from "@/admin/training-sources/TrainingSourceTable"
import { TrainingSourceKind } from "@/admin/training-sources/__generated__/TrainingSourceSettingsFormFragment.graphql"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import DiscoTableSearchInput from "@disco-ui/table/header/search/DiscoTableSearchInput"
import { TestIDProps } from "@utils/typeUtils"
import { useState } from "react"

interface Props extends TestIDProps {
  kind: TrainingSourceKind
}

export default function TrainingSourcesDrawerContent({
  testid = "TrainingSourcesDrawerContent",
  kind,
}: Props) {
  const classes = useStyles()
  const [search, setSearch] = useState("")

  return (
    <>
      <CreateTrainingSourceButton variant={"dashed"} kind={kind}>
        {`New ${kind === "web_crawl" ? "Link" : "Knowledge Base"}`}
      </CreateTrainingSourceButton>
      <DiscoTableSearchInput
        testid={`${testid}.search`}
        onChange={handleSearch}
        classes={{
          root: classes.search,
        }}
      />

      <TrainingSourceTable kind={kind} search={search} />
    </>
  )

  function handleSearch(value: string) {
    setSearch(value)
  }
}

const useStyles = makeUseStyles((theme) => ({
  search: {
    marginTop: theme.spacing(3),
  },
}))
